<template>
	<BaseLayout background-color-class="bg-color-greige" :include-padding="true" :vertically-centered="true">
		<template #header>
			<HeaderBasic></HeaderBasic>
		</template>
		<section class="container">
			<div class="display-flex-md gutters-300-md justify-content-center">
				<div class="col-8-md col-6-lg">
					<LoginForm />
				</div>
			</div>
		</section>
	</BaseLayout>
</template>

<script setup lang="ts">
import HeaderBasic from '@components/header/header-basic.vue';
import LoginForm from '@components/login/login-form.vue';
</script>
